var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { determineActualUrl, getClientHints } from '../lib';
import clearParams from './clearParams';
import createSandbox from './createSandbox';
import getPerformanceMetrics from './getPerformanceMetrics';
import getPreviousPage from './getPreviousPage';
import { API_VERSION, DEDUPLICATION_ID_ALLOWLIST, PARAM_REGEX, TTT_VERSION, } from '../constants';
import abacus from './trackers/abacus';
import nwt from './trackers/nwt';
var isRegex = function (value) { return value instanceof RegExp; };
var isString = function (value) { return typeof value === 'string'; };
var createClearParamsFilter = function (clearParams) {
    if (typeof clearParams === 'function') {
        return clearParams;
    }
    else if (clearParams === true) {
        return function (param) { return PARAM_REGEX.test(param); };
    }
    else if (isRegex(clearParams)) {
        return function (param) { return clearParams.test(param); };
    }
    else if (isString(clearParams)) {
        return function (param) { return clearParams === param; };
    }
    else {
        return null;
    }
};
var splitConfigs = function (env, config) {
    // filter ttt only configuration
    var clearParams = config.clearParams, host = config.host, sandboxFile = config.sandboxFile, sandboxUrl = config.sandboxUrl, stmConfig = __rest(config, ["clearParams", "host", "sandboxFile", "sandboxUrl"]);
    var tttConfig = {
        clearParams: clearParams,
        host: host,
        sandboxFile: sandboxFile,
        sandboxUrl: sandboxUrl,
    };
    return [buildTTTConfig(env, tttConfig), buildSTMConfig(env, stmConfig)];
};
var buildSTMConfig = function (env, config) {
    var search = (window.location || {}).search;
    return Object.assign({
        debug: /debug=true/.test(search),
    }, config, {
        env: env,
    });
};
var buildTTTConfig = function (env, config) {
    var clearParams = config.clearParams, _a = config.host, sandboxHost = _a === void 0 ? env === 'production'
        ? 'stan.xing.com'
        : 'stan.preview.xing.com' : _a, _b = config.sandboxFile, sandboxFile = _b === void 0 ? "stm-".concat(API_VERSION, ".html") : _b, _c = config.sandboxUrl, sandboxUrl = _c === void 0 ? "https://".concat(sandboxHost, "/").concat(sandboxFile) : _c;
    return { clearParams: clearParams, sandboxUrl: sandboxUrl };
};
var throwInitError = function () {
    throw new Error('Please call ttt.init first');
};
var setupTracking = function (window) {
    var ttt = {
        version: TTT_VERSION,
        baseData: {},
        _dl: {},
        _sandbox: createSandbox(window),
        _clearParamsFilter: undefined,
        _clientHints: undefined,
        _initCalled: false,
        _env: undefined,
    };
    var assertInitialization = function () {
        if (!ttt._initCalled) {
            throwInitError();
        }
    };
    ttt.assign = Object.assign;
    ttt.init = function (env_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([env_1], args_1, true), void 0, function (env, config) {
            var _a, tttConfig, stmConfig, _b, clearParams, sandboxUrl, _c;
            if (config === void 0) { config = {}; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // return silently, because it should be possible to call init multiple times
                        if (ttt._initCalled)
                            return [2 /*return*/];
                        ttt._initCalled = true;
                        ttt._env = env;
                        _a = splitConfigs(env, config), tttConfig = _a[0], stmConfig = _a[1];
                        _b = tttConfig.clearParams, clearParams = _b === void 0 ? true : _b, sandboxUrl = tttConfig.sandboxUrl;
                        ttt._sandbox.load(sandboxUrl);
                        if (clearParams) {
                            ttt._clearParamsFilter = createClearParamsFilter(clearParams);
                        }
                        _c = ttt;
                        return [4 /*yield*/, getClientHints()];
                    case 1:
                        _c._clientHints = _d.sent();
                        return [2 /*return*/, ttt._sandbox.publish('stm:init', stmConfig)];
                }
            });
        });
    };
    ttt.pageview = function (channel, pageName, baseData, contextData) {
        assertInitialization();
        // copy base data for later usage
        ttt.baseData = Object.assign({}, baseData);
        // create the data layer for events
        ttt._dl = Object.assign({}, baseData, {
            PropChannel: channel,
            pageName: pageName,
            PropDestinationUrl: window.location.href,
            PropReferringUrl: (ttt._dl && ttt._dl.PropDestinationUrl) || window.document.referrer,
        });
        if (ttt._clearParamsFilter) {
            ttt._clearParams(ttt._clearParamsFilter);
        }
        return ttt._rawEvent('pageview', Object.assign({}, ttt._dl, contextData));
    };
    ttt.event = function (name, contextData) {
        assertInitialization();
        var props = Object.assign({}, ttt._dl, contextData);
        return ttt._rawEvent(name, props);
    };
    ttt.nwtEvent = function (eventData) {
        assertInitialization();
        var screenUrl = determineActualUrl(ttt._dl.PropDestinationUrl, window.location.href);
        var data = nwt.enrichEvents(eventData, screenUrl, ttt._clientHints);
        nwt.track(data, ttt._env);
        ttt._sandbox.publish('stm:trackNWT', data);
    };
    ttt.withPerformanceMetrics = function (action) {
        assertInitialization();
        return new Promise(function (resolve) {
            var resolveWithMetrics = function () {
                setTimeout(function () {
                    var times = getPerformanceMetrics(window);
                    var metrics = Object.keys(times)
                        .map(function (name) { return "".concat(name, "=").concat(times[name]); })
                        .join(';');
                    var props = { PropTechnicalPerformance: metrics };
                    action && action(props);
                    resolve(props);
                }, 0);
            };
            if ((window.document && window.document.readyState === 'complete') ||
                !window.addEventListener) {
                resolveWithMetrics();
            }
            else {
                var onReady_1 = function () {
                    resolveWithMetrics();
                    window.removeEventListener('load', onReady_1, true);
                };
                window.addEventListener('load', onReady_1, true);
            }
        });
    };
    ttt.publish = function (action, payload, options) {
        if (options === void 0) { options = {}; }
        assertInitialization();
        return ttt._sandbox.publish(action, payload, options);
    };
    ttt.subscribe = function (name, callback) {
        assertInitialization();
        return ttt._sandbox.subscribe(name, callback);
    };
    ttt._clearParams = function (filter) {
        assertInitialization();
        return clearParams(filter);
    };
    ttt._rawEvent = function (event, props) {
        var _a;
        assertInitialization();
        var prevPage = getPreviousPage(props.pageName, 'adobe');
        props = Object.assign({}, props, {
            PropLastPage: prevPage,
            PropLastPageCookieSet: 1, // can be removed once ttt 1.8.1 is rolled out completely
        });
        if (DEDUPLICATION_ID_ALLOWLIST.includes((_a = props.pageName) === null || _a === void 0 ? void 0 : _a.split('/')[0])) {
            props = Object.assign(props, {
                PropDeduplicationId: crypto.randomUUID(),
            });
        }
        return Promise.all([
            abacus.track(ttt._env, event, props),
            ttt._sandbox.publish('stm:track', { event: event, props: props }),
        ]);
    };
    ttt._rawPageview = ttt._rawEvent.bind(null, 'pageview');
    ttt._unload = function () {
        return ttt._sandbox.unload();
    };
    return ttt;
};
export default setupTracking;
export { splitConfigs, buildTTTConfig, buildSTMConfig, createClearParamsFilter, };
